var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ApiService } from "../../lib/http.service";
import iconFather from "../../assets/feather/father-at-yarisi.svg";
import _ from "lodash";
import { env } from "../../definitions/global.vars";
import { availableBettingSubTypes, availableTjkBettingTypes, DailyRaces, tjkBetSlipActionSubject, tjkBetSlipOptions, tjkBetSlipVisibleSubject, } from './tjk.store';
import { addToTJKBetSlip, clearTjkBetSlip, } from './tjk.betslip.service';
import { getAvailableBettingSubTypes, getAvailableBettingTypes, getDailyRaces, } from './tjk.utils';
import { betSlipToggle } from './components/tjk.betslip';
var reloadDataTimer = null;
export var MuhtemellerData = [];
var WAGER_BET_TYPE_MAP = { "İKİLİ": 10, "SIRALI İKİLİ": 8, "ÇİFTE": 14 };
export function TjkMuhtemeller() {
    var _a, _b, _c;
    var api = new ApiService();
    var _d = useState(null), hippodrome = _d[0], setHippodrome = _d[1];
    var _e = useState(0), shownRun = _e[0], setShownRun = _e[1];
    var _f = useState(1), selectedWagerIndex = _f[0], setSelectedWagerIndex = _f[1];
    var width = window.innerWidth;
    var isMobile = width < 986;
    var applyInitialSelection = function (data) {
        var _a, _b;
        var keyword = (_a = tjkBetSlipOptions.hippodrome) === null || _a === void 0 ? void 0 : _a.keyword;
        var hippodromeId = (_b = tjkBetSlipOptions.hippodrome) === null || _b === void 0 ? void 0 : _b.id;
        var runNo = tjkBetSlipOptions.selectedRun;
        var targetHp = keyword
            ? data.find(function (h) { return h.keyword === keyword; })
            : hippodromeId
                ? data.find(function (h) { return String(h.id) === String(hippodromeId); })
                : null;
        var hp = targetHp || data[0];
        if (!hp)
            return;
        setHippodrome(hp);
        if (runNo != null && hp.runs) {
            var runIdx = hp.runs.findIndex(function (r) { return String(r.no) === String(runNo); });
            setShownRun(runIdx > -1 ? runIdx : 0);
        }
        else {
            setShownRun(0);
        }
    };
    useEffect(function () {
        document.getElementById('tjkLoading').style.display = 'block';
        LoadData(true);
        reloadDataTimer = setInterval(function () { LoadData(); }, 3000);
        return function () { clearInterval(reloadDataTimer); };
    }, []);
    var LoadData = function (isFirst) {
        if (isFirst === void 0) { isFirst = false; }
        if (isFirst === true && MuhtemellerData.length !== 0) {
            applyInitialSelection(MuhtemellerData);
            document.getElementById('tjkLoading').style.display = 'none';
        }
        else {
            api.start('get', env.ekuri_bulletin_api + '/api/possibles', null, true).then(function (result) {
                if (result.status) {
                    if (MuhtemellerData.length === 0) {
                        Object.assign(MuhtemellerData, result.data);
                        if (MuhtemellerData.length > 0) {
                            applyInitialSelection(MuhtemellerData);
                        }
                    }
                    else {
                        var _loop_1 = function (newHippodrome) {
                            var exHippodrome = MuhtemellerData.find(function (el) { return el.id === newHippodrome.id; });
                            if (exHippodrome) {
                                for (var _b = 0, _c = Object.entries(newHippodrome); _b < _c.length; _b++) {
                                    var _d = _c[_b], key = _d[0], value = _d[1];
                                    if (!['runs'].includes(key) && exHippodrome[key] !== value) {
                                        exHippodrome[key] = value;
                                    }
                                    else if (key === 'runs') {
                                        if (newHippodrome.runs) {
                                            var _loop_2 = function (newRun) {
                                                var exRun = exHippodrome.runs.find(function (el) { return el.no === newRun.no; });
                                                if (exRun) {
                                                    for (var _g = 0, _h = Object.entries(newRun); _g < _h.length; _g++) {
                                                        var _j = _h[_g], rkey = _j[0], rValue = _j[1];
                                                        if (!['horses'].includes(rkey) && exRun[rkey] !== rValue) {
                                                            exRun[rkey] = rValue;
                                                        }
                                                        else if ('horses' === rkey) {
                                                            if (newRun.horses) {
                                                                var _loop_3 = function (newHorse) {
                                                                    var exHorse = exRun.horses.find(function (el) { return el.no === newHorse.no; });
                                                                    if (exHorse) {
                                                                        for (var _m = 0, _o = Object.entries(newHorse); _m < _o.length; _m++) {
                                                                            var _p = _o[_m], hkey = _p[0], hValue = _p[1];
                                                                            if (exHorse[hkey] !== hValue)
                                                                                exHorse[hkey] = hValue;
                                                                        }
                                                                    }
                                                                    else if (newHorse.run_status) {
                                                                        exRun.horses.push(newHorse);
                                                                    }
                                                                };
                                                                for (var _k = 0, _l = newRun.horses; _k < _l.length; _k++) {
                                                                    var newHorse = _l[_k];
                                                                    _loop_3(newHorse);
                                                                }
                                                            }
                                                            else {
                                                                exRun['horses'] = [];
                                                            }
                                                        }
                                                    }
                                                }
                                                else if (Number(newRun.status) === 0) {
                                                    exHippodrome.runs.push(newRun);
                                                }
                                            };
                                            for (var _e = 0, _f = newHippodrome.runs; _e < _f.length; _e++) {
                                                var newRun = _f[_e];
                                                _loop_2(newRun);
                                            }
                                        }
                                        else {
                                            exHippodrome['runs'] = [];
                                        }
                                    }
                                }
                            }
                            else {
                                MuhtemellerData.push(newHippodrome);
                            }
                        };
                        for (var _i = 0, _a = result.data; _i < _a.length; _i++) {
                            var newHippodrome = _a[_i];
                            _loop_1(newHippodrome);
                        }
                    }
                }
                document.getElementById('tjkLoading').style.display = 'none';
            });
        }
    };
    var changeHippodrome = function (hp) {
        setHippodrome(hp);
        setSelectedWagerIndex(1);
        var openIdx = hp.runs.findIndex(function (r) { return r.status === 'AÇIK'; });
        setShownRun(openIdx > -1 ? openIdx : hp.runs.length - 1);
    };
    useEffect(function () {
        Array.from(document.getElementsByClassName('muht-line')).forEach(function (el) {
            return el.classList.remove('high', 'low');
        });
    }, [hippodrome, shownRun]);
    var colorHorses = function (h1, h2) {
        Array.from(document.getElementsByClassName('muht-line')).forEach(function (el) {
            return el.classList.remove('high', 'low');
        });
        if (h2 === null || h2 === undefined) {
            Array.from(document.getElementsByClassName("first-horse-".concat(h1))).forEach(function (el) { return el.classList.add('high'); });
            Array.from(document.getElementsByClassName("second-horse-".concat(h1))).forEach(function (el) { return el.classList.add('low'); });
        }
        else {
            Array.from(document.getElementsByClassName("first-horse-".concat(h1, " second-horse-null"))).forEach(function (el) { return el.classList.add('high'); });
            Array.from(document.getElementsByClassName("first-horse-".concat(h2, " second-horse-null"))).forEach(function (el) { return el.classList.add('low'); });
            Array.from(document.getElementsByClassName("first-horse-".concat(h1, " second-horse-").concat(h2))).forEach(function (el) { return el.classList.add('high'); });
        }
    };
    var addPossibilityToBetSlip = function (possibility, wagerName, runNo, ganyanPossibilities) {
        var betTypeId = WAGER_BET_TYPE_MAP[wagerName];
        if (!betTypeId)
            return;
        var doAdd = function (drHippodrome) {
            tjkBetSlipOptions.hippodrome = drHippodrome;
            getAvailableBettingTypes();
            var bettingType = availableTjkBettingTypes.find(function (bt) { return Number(bt.id) === betTypeId; });
            if (!bettingType)
                return;
            tjkBetSlipOptions.bettingType = bettingType;
            getAvailableBettingSubTypes(drHippodrome);
            var subType;
            if (betTypeId === 14) {
                subType = availableBettingSubTypes.find(function (st) { return String(st).startsWith(String(runNo) + '-'); });
            }
            else {
                subType = availableBettingSubTypes.find(function (st) { return Number(st) === Number(runNo); });
            }
            if (!subType)
                return;
            tjkBetSlipOptions.bettingSubType = subType;
            var getHorseName = function (no) { var _a; return ((_a = ganyanPossibilities.find(function (p) { return Number(p.result1) === no; })) === null || _a === void 0 ? void 0 : _a.horse_name_lower) || "At ".concat(no); };
            var makeHorse = function (no, run) {
                var _a;
                var drHorse = (_a = run === null || run === void 0 ? void 0 : run.horses) === null || _a === void 0 ? void 0 : _a.find(function (h) { return Number(h.no) === no; });
                return drHorse || { no: no, name: getHorseName(no), run_status: true };
            };
            var run1 = drHippodrome.runs.find(function (r) { return Number(r.no) === Number(runNo); });
            if (!run1)
                return;
            var run2 = betTypeId === 14
                ? drHippodrome.runs.find(function (r) { return Number(r.no) === Number(runNo) + 1; })
                : run1;
            var horse1 = makeHorse(Number(possibility.result1), run1);
            var horse2 = possibility.result2 != null
                ? makeHorse(Number(possibility.result2), run2 || run1)
                : null;
            clearTjkBetSlip();
            if (betTypeId === 14) {
                if (!run2)
                    return;
                addToTJKBetSlip(1, run1, horse1, 'add');
                if (horse2)
                    addToTJKBetSlip(2, run2, horse2, 'add');
            }
            else {
                addToTJKBetSlip(1, run1, horse1, 'add');
                if (horse2)
                    addToTJKBetSlip(2, run1, horse2, 'add');
            }
            tjkBetSlipActionSubject.next({ action: 'add', run: run1, column: 1 });
            if (!betSlipToggle) {
                tjkBetSlipVisibleSubject.next(undefined);
            }
        };
        var drHippodrome = DailyRaces.find(function (h) { return h.keyword === (hippodrome === null || hippodrome === void 0 ? void 0 : hippodrome.keyword); });
        if (drHippodrome) {
            doAdd(drHippodrome);
        }
        else {
            getDailyRaces().then(function () {
                drHippodrome = DailyRaces.find(function (h) { return h.keyword === (hippodrome === null || hippodrome === void 0 ? void 0 : hippodrome.keyword); });
                if (drHippodrome)
                    doAdd(drHippodrome);
            });
        }
    };
    var eqStyles = {
        "1": { transform: 'scaleX(-1)', marginLeft: 4, filter: 'brightness(0)', width: 11 },
        "2": { transform: 'scaleX(-1)', marginLeft: 4, filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(359deg) brightness(94%) contrast(117%)', width: 11 },
        "3": { transform: 'scaleX(-1)', marginLeft: 4, width: 11 },
    };
    var currentRun = (_a = hippodrome === null || hippodrome === void 0 ? void 0 : hippodrome.runs) === null || _a === void 0 ? void 0 : _a[shownRun];
    var isRunOpen = (currentRun === null || currentRun === void 0 ? void 0 : currentRun.status) === 'AÇIK';
    var ganyanPossibilities = ((_c = (_b = currentRun === null || currentRun === void 0 ? void 0 : currentRun.wagers) === null || _b === void 0 ? void 0 : _b.find(function (w) { return w.wager === 'GANYAN'; })) === null || _c === void 0 ? void 0 : _c.possibilities) || [];
    return (_jsxs(_Fragment, { children: [!isMobile && hippodrome && (_jsx("div", __assign({ className: "header clearfix pl-lg-0 mt-sm-0" }, { children: _jsx("ul", __assign({ className: "locationtab clearfix float-left", style: { width: 'max-content' } }, { children: MuhtemellerData.map(function (data, key) {
                        if (data.keyword === 'KARMA')
                            return null;
                        return (_jsx("li", __assign({ className: "cursor-pointer tjklocation " + (hippodrome.keyword === data.keyword ? 'activeTab' : ''), onClick: function () { return changeHippodrome(data); } }, { children: data.hippodrome }), key));
                    }) }), void 0) }), void 0)), isMobile && MuhtemellerData.length > 0 && (_jsx("div", __assign({ className: "muht-hippodrome-select-wrapper" }, { children: _jsx("select", __assign({ className: "muht-hippodrome-select", value: (hippodrome === null || hippodrome === void 0 ? void 0 : hippodrome.keyword) || '', onChange: function (e) {
                        var found = MuhtemellerData.find(function (d) { return d.keyword === e.target.value; });
                        if (found)
                            changeHippodrome(found);
                    } }, { children: MuhtemellerData.map(function (data, key) {
                        if (data.keyword === 'KARMA')
                            return null;
                        return (_jsx("option", __assign({ value: data.keyword }, { children: data.hippodrome }), key));
                    }) }), void 0) }), void 0)), hippodrome && hippodrome.runs ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "muht-run-tabs" }, { children: hippodrome.runs.map(function (r, idx) { return (_jsxs("div", __assign({ className: "muht-run-tab".concat(shownRun === idx ? ' active' : ''), onClick: function () { setShownRun(idx); setSelectedWagerIndex(1); } }, { children: [_jsxs("span", __assign({ className: "muht-run-num" }, { children: [r.no, "."] }), void 0), _jsx("span", __assign({ className: "muht-run-lbl" }, { children: "Ko\u015Fu" }), void 0)] }), idx)); }) }), void 0), currentRun && (_jsxs("div", __assign({ className: "muht-run-info-bar" }, { children: [_jsxs("strong", { children: [currentRun.no, ". Ko\u015Fu"] }, void 0), _jsx("span", __assign({ className: "muht-info-sep" }, { children: "\u00B7" }), void 0), _jsx("span", { children: currentRun.clock }, void 0), _jsx("span", __assign({ className: "muht-run-badge".concat(isRunOpen ? ' open' : '') }, { children: isRunOpen ? 'BAHSE AÇIK' : 'KOŞULDU' }), void 0)] }), void 0)), isMobile && (currentRun === null || currentRun === void 0 ? void 0 : currentRun.wagers) && currentRun.wagers.length > 1 && (_jsx("div", __assign({ className: "muht-pill-tabs" }, { children: currentRun.wagers.map(function (w, idx) {
                            if (idx === 0)
                                return null;
                            return (_jsx("span", __assign({ className: "muht-pill-tab".concat(selectedWagerIndex === idx ? ' active' : ''), onClick: function () { return setSelectedWagerIndex(idx); } }, { children: w.wager }), idx));
                        }) }), void 0)), (currentRun === null || currentRun === void 0 ? void 0 : currentRun.wagers) && (_jsx("div", __assign({ className: "muht-table-wrapper" }, { children: _jsx("div", __assign({ className: "muht-cols-row" }, { children: currentRun.wagers.map(function (r, key) {
                                if (isMobile && key !== 0 && key !== selectedWagerIndex)
                                    return null;
                                var isSelectedOnMobile = isMobile && key === selectedWagerIndex && key !== 0;
                                var canAdd = key !== 0 && isRunOpen && WAGER_BET_TYPE_MAP[r.wager];
                                return (_jsxs("div", __assign({ className: "muht-runs".concat(isSelectedOnMobile ? ' muht-runs-selected' : '') }, { children: [_jsx("div", __assign({ className: "muht-caption" }, { children: r.wager }), void 0), r.possibilities.map(function (p, pkey) {
                                            var minGanyan = _.orderBy(r.possibilities, [function (a) { return Number(a.ganyan); }], ['asc'])[0];
                                            var isBest = key === 0 && Number(minGanyan.ganyan) === Number(p.ganyan);
                                            var isKosmaz = p.ganyan === '-';
                                            var h2Class = (p.result2 !== null && p.result2 !== undefined) ? p.result2 : 'null';
                                            return (_jsxs("div", __assign({ className: "muht-line first-horse-".concat(p.result1, " second-horse-").concat(h2Class), onMouseOver: function () { var _a; return colorHorses(p.result1, (_a = p.result2) !== null && _a !== void 0 ? _a : null); } }, { children: [_jsxs("span", __assign({ className: "muht-horse-info".concat(isBest ? ' best' : '') }, { children: [_jsxs("span", __assign({ className: "muht-horse-numbers" }, { children: [p.result1, key !== 0 && " - ".concat(p.result2)] }), void 0), key === 0 && p.horse_name_lower && (_jsxs("span", __assign({ className: "muht-horse-name" }, { children: [" ", p.horse_name_lower] }), void 0)), key === 0 && ["1", "2", "3"].includes(p.stablemate) && (_jsx("img", { src: iconFather, style: eqStyles[p.stablemate], alt: "" }, void 0))] }), void 0), _jsx("span", __assign({ className: "muht-odds".concat(isBest ? ' best' : '').concat(isKosmaz ? ' kosmaz' : '') }, { children: isKosmaz ? (isMobile ? 'K' : 'KOŞMAZ') : p.ganyan }), void 0), canAdd && (_jsx("button", __assign({ className: "muht-add-btn", title: "Betslipe Ekle", onClick: function (e) {
                                                            e.stopPropagation();
                                                            addPossibilityToBetSlip(p, r.wager, currentRun.no, ganyanPossibilities);
                                                        } }, { children: "+" }), void 0))] }), pkey));
                                        })] }), key));
                            }) }), void 0) }), void 0))] }, void 0)) : _jsx(_Fragment, {}, void 0)] }, void 0));
}
